import React from "react";

import { isObject } from "lodash";
import { viewportContext } from "../../contexts/ViewportContext";
import { DEFAULT_BREAKPOINTS } from "../../utils/constants/viewConstants";

export const useViewport = (values, customBreakpoints = DEFAULT_BREAKPOINTS) =>  {
    const { width } = React.useContext(viewportContext);
    
    if(!isObject(values) || !isObject(customBreakpoints))
    {
        return values;
    }

    if(customBreakpoints.xl !== undefined && width >= customBreakpoints.xl && values.xl !== undefined)
    {
        return values.xl;
    }

    if(customBreakpoints.lgxl !== undefined && width >= customBreakpoints.lgxl && values.lgxl !== undefined)
    {
        return values.lgxl;
    }

    if(customBreakpoints.lg !== undefined && width >= customBreakpoints.lg && values.lg !== undefined)
    {
        return values.lg;
    }

    if(customBreakpoints.mdlg !== undefined && width >= customBreakpoints.mdlg && values.mdlg !== undefined)
    {
        return values.mdlg;
    }

    if(customBreakpoints.md !== undefined && width >= customBreakpoints.md && values.md !== undefined)
    {
        return values.md;
    }

    if(customBreakpoints.smmd !== undefined && width >= customBreakpoints.smmd && values.smmd !== undefined)
    {
        return values.smmd;
    }

    if(customBreakpoints.sm !== undefined && width >= customBreakpoints.sm && values.sm !== undefined)
    {
        return values.sm;
    }

    if(customBreakpoints.xssm !== undefined && width >= customBreakpoints.xssm && values.xssm !== undefined)
    {
        return values.xssm;
    }

    if(customBreakpoints.xs !== undefined && width >= customBreakpoints.xs && values.xs !== undefined)
    {
        return values.xs;
    }

    return values;
}